<template>
  <div class="legend">
    <div class="legend-title is-italic has-text-weight-bold has-text-grey-light">
      Legend
    </div>
    <div class="legend-content is-flex">
      <div class="indicator-type is-flex">
        <div class="indicator-title is-flex has-text-weight-bold has-text-grey">
          Match Indicators
        </div>
        <div class="indicator-values is-flex">
          <div class="indicator-value is-flex">
            <div class="indicator-icon is-flex">
              <es-near-match/>
            </div>
            <div class="indicator-summary is-flex-block">
              <div class="is-flex">
                Near Match
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EsNearMatch from '@/components/EsNearMatch.vue';

export default {
  props: ['lower', 'upper'],
  components: {
    EsNearMatch,
  },
};
</script>

<style lang="sass" scoped>
  .legend
    background-color: #f9f9f9
    padding: 0rem 1rem
    box-shadow: #AAA 0px 1px 3px
    font-size: 12px
    // min-height: 200px
  .legend-title
    padding: .25rem 0rem
    border-bottom: 1px solid #EEE
  .legend-content
    padding: 1rem 0rem
    margin-left: -1rem
    // min-height: 100px
  .indicator-type
    min-width: 200px
    flex-direction: column
    border-right: 1px solid #EEE
    padding-left: 1rem
  .indicator-title
    padding: .25rem 0rem
  .indicator-values
    height: 100%
    padding: .5rem 2rem .5rem 0rem
  .indicator-value
    min-width: 100px
    padding-right: 2rem
  .indicator-icon
    padding-right: 1rem
    align-items: center
  .indicator-summary
    justify-content: center
    margin: auto
  .indicator-name
    align-items: center
  .no-wrap
    white-space: nowrap
</style>
